function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#comments-and-reactions-metric_svg__filter0_dd_10176_12195)",
  clipPath: "url(#comments-and-reactions-metric_svg__clip0_10176_12195)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.667,
  y: 0.379,
  width: 202,
  height: 43.913,
  rx: 21.956,
  fill: "#272D33"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comments-and-reactions-metric_svg__clip1_10176_12195)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.896 22.294c0-.245-.058-.476-.156-.685-.655-2.11-3.718-1.956-8.075-2.06-.728-.016-.312-.877-.056-2.765.166-1.228-.626-3.114-1.957-3.114-2.194 0-.083 1.731-2.024 6.012-1.036 2.288-3.354 1.006-3.354 3.304v5.23c0 .894.088 1.754 1.346 1.896 1.22.137.945 1.006 2.704 1.006h8.804c.897 0 1.626-.73 1.626-1.627 0-.372-.13-.71-.34-.985.497-.278.839-.804.839-1.414 0-.37-.13-.71-.34-.983.5-.278.842-.805.842-1.416 0-.443-.18-.845-.469-1.14.37-.298.61-.748.61-1.259z",
  fill: "#FFDB5E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.073 23.92h4.197c.571 0 1.107-.305 1.399-.796a.427.427 0 00-.735-.435.775.775 0 01-.664.378h-4.299a.773.773 0 010-1.545h2.873a.427.427 0 000-.854H24.97c-.897 0-1.626.73-1.626 1.627 0 .5.232.942.588 1.24a1.62 1.62 0 00-.487 1.159c0 .501.233.945.591 1.243a1.619 1.619 0 00.204 2.479 1.613 1.613 0 00-.415 1.075c0 .897.73 1.627 1.626 1.627h2.676c.57 0 1.107-.305 1.399-.797a.427.427 0 00-.734-.436.778.778 0 01-.665.379h-2.676a.773.773 0 010-1.545h3.174c.571 0 1.108-.306 1.4-.797a.427.427 0 00-.735-.436.767.767 0 01-.665.38H25.18a.774.774 0 010-1.546h3.948c.57 0 1.107-.305 1.399-.797a.427.427 0 00-.734-.436.767.767 0 01-.665.379h-4.055a.773.773 0 010-1.545z",
  fill: "#EE9547"
})), /*#__PURE__*/React.createElement("rect", {
  x: 44.58,
  y: 4.77,
  width: 35.13,
  height: 35.13,
  rx: 17.565,
  fill: "#BBD9F6",
  fillOpacity: 0.13
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comments-and-reactions-metric_svg__clip2_10176_12195)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.871 19.326a4.815 4.815 0 00-4.814-4.815 4.806 4.806 0 00-3.912 2.015 4.805 4.805 0 00-3.912-2.014 4.814 4.814 0 00-4.815 4.814c0 .377.048.742.13 1.094.669 4.153 5.287 8.535 8.597 9.739 3.31-1.203 7.928-5.586 8.596-9.739.082-.352.13-.717.13-1.094z",
  fill: "#DD2E44"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comments-and-reactions-metric_svg__clip3_10176_12195)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M110.449 22.335a8.782 8.782 0 11-8.782-8.782 8.783 8.783 0 018.782 8.782z",
  fill: "#FFCC4D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.769 22.236c-.029-.066-.732-1.608-2.175-1.608-1.443 0-2.145 1.543-2.175 1.608a.245.245 0 00.369.296c.006-.005.616-.44 1.806-.44 1.184 0 1.793.43 1.806.44a.244.244 0 00.369-.296zm-5.855 0c-.03-.066-.732-1.608-2.175-1.608-1.443 0-2.145 1.543-2.175 1.608a.243.243 0 00.07.289c.087.069.209.072.298.007.007-.005.616-.44 1.807-.44 1.184 0 1.793.43 1.806.44a.244.244 0 00.369-.296zm7.096-.876a.49.49 0 01-.454-.307c-.867-2.17-3.036-2.626-3.058-2.63a.487.487 0 11.192-.957c.11.021 2.711.57 3.772 3.224a.488.488 0 01-.452.67zm-12.686 0a.488.488 0 01-.453-.67c1.062-2.654 3.662-3.202 3.773-3.224a.489.489 0 01.193.956c-.09.019-2.199.478-3.06 2.63a.49.49 0 01-.453.308zm6.343 2.927c-1.768 0-2.941-.206-4.392-.488-.331-.064-.976 0-.976.976 0 1.952 2.242 4.391 5.368 4.391 3.124 0 5.367-2.44 5.367-4.391 0-.976-.645-1.04-.976-.976-1.451.282-2.624.488-4.391.488z",
  fill: "#664500"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.275 24.775s1.464.488 4.392.488c2.927 0 4.391-.488 4.391-.488s-.976 1.952-4.391 1.952c-3.416 0-4.392-1.952-4.392-1.952z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.177 27.326a2.44 2.44 0 11-4.73-1.2c.331-1.307 3.092-4.25 3.565-4.13.474.121 1.496 4.025 1.165 5.33zm6.97 0a2.44 2.44 0 104.729-1.2c-.331-1.307-3.092-4.25-3.565-4.13-.473.121-1.495 4.025-1.164 5.33z",
  fill: "#5DADEC"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comments-and-reactions-metric_svg__clip4_10176_12195)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M149.483 22.637c0-1.85-1.5-3.351-3.351-3.351-.478 0-1.343.282-1.343.282l-6.405.675s-1.325-.771-2.138-.771a3.351 3.351 0 00-3.335 3.694c.181 4.42 3.812 7.952 8.277 7.952a8.295 8.295 0 008.295-8.295c0-.025-.004-.049-.006-.074.002-.037.006-.074.006-.112z",
  fill: "#FFCB4C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.105 20.262c-.459-.119-.492.189-1.074.12-.57-.067.209-.36-.096-.533-.102-.058-.249-.07-.43-.047-.513.063-8.272.265-8.562.404-.257.125-.409.268-.643.05-.294-.274-.715-.116-.837-.025-.157.118-.19.352.114.623.303.205.817.42 1.691.566.096.016.178.022.255.025.598.02.681-.815 1.527-.837.554-.015 5.442.522 5.844.467.049-.007.101-.012.161-.012.762 0 .939.708 1.751.155.344-.28.883-.805.299-.956z",
  fill: "#F19020"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.303 18a9.805 9.805 0 011.64 2.207c.277.502.467.941.58 1.238.598.02.681-.326 1.527-.349.554-.015.87.375 1.28.6.732.4 1.253-.356 1.814-.356.415 0 1.083.588 1.55.372.677-.313.798-.58 1.2-.636.157-.386.362-.827.611-1.273.361-.646.819-1.3 1.386-1.802h-11.588z",
  fill: "#F36C24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.705 18.156c.625-.616-11.241.008-10.901.385.482.534 1.074 1.538 1.074 1.538s2.321 1.174 4.074-.305c1.22.732 2.928.473 3.69-.785 0 0 .594.22 1.196.259 0 0 .465-.695.867-1.092z",
  fill: "#CE5C1F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.188 29.941c1.168 0 2.114-1.081 2.114-2.415s-.946-2.415-2.114-2.415c-1.167 0-2.113 1.08-2.113 2.415 0 1.334.946 2.415 2.113 2.415zM139.237 23.607c0 .719-.438 1.301-.976 1.301-.539 0-.976-.582-.976-1.301s.437-1.301.976-1.301c.538 0 .976.582.976 1.301zm5.855 0c0 .718-.437 1.3-.976 1.3-.539 0-.976-.582-.976-1.3 0-.719.437-1.302.976-1.302.539 0 .976.583.976 1.302z",
  fill: "#65471B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.592 15.37c-.117 0-.228.023-.334.054a1.82 1.82 0 00-1.414-.681c-.043 0-.083.01-.125.012a1.943 1.943 0 00-1.457-.663c-.735 0-1.366.41-1.701 1.008a1.09 1.09 0 00-1.866-.24 1.825 1.825 0 00-1.723-1.235c-.645 0-1.21.336-1.536.84-.09-.014-.179-.028-.273-.028-.699 0-1.298.396-1.607.972a1.647 1.647 0 10-.304 3.263c.287 0 .554-.078.787-.207a1.091 1.091 0 00.862.201 2.356 2.356 0 002.005 1.124c.834 0 1.565-.432 1.988-1.082.351.43.879.71 1.478.71a1.91 1.91 0 001.842-1.42c.017.001.032.005.048.005.138 0 .273-.015.403-.042.319.271.728.441 1.18.441.572 0 1.078-.269 1.413-.681.107.031.218.053.335.053a1.203 1.203 0 00-.001-2.404z",
  fill: "#CCD6DD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.968 17.402a1.035 1.035 0 10-.001-2.07 1.035 1.035 0 00.001 2.07zM142.104 16.433c0-.582-.472-1.054-1.054-1.054-.18 0-.347.05-.494.128a.813.813 0 00-1.418-.15 1.82 1.82 0 00-1.243-.493c-.856 0-1.569.59-1.769 1.384a.982.982 0 10.122 1.23c.252.528.746.915 1.341 1.015a1.095 1.095 0 002.016-.31c.158.088.337.143.53.143.522 0 .958-.366 1.069-.854.508-.076.9-.51.9-1.039z",
  fill: "#E1E8ED"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comments-and-reactions-metric_svg__clip5_10176_12195)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M189.493 22.335a8.783 8.783 0 11-17.565-.001 8.783 8.783 0 0117.565.001z",
  fill: "#FFCC4D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.362 28.131c-.022-.087-.57-2.136-3.652-2.136-3.083 0-3.63 2.05-3.652 2.136a.243.243 0 00.116.27.246.246 0 00.292-.037c.01-.009.954-.905 3.244-.905s3.235.896 3.244.905a.245.245 0 00.292.04.245.245 0 00.116-.273zm-4.771-6.14c-1.588-1.589-4.14-1.607-4.248-1.607a.487.487 0 00-.001.976c.015 0 .94.01 1.944.36-.289.312-.479.797-.479 1.347 0 .944.546 1.708 1.22 1.708.673 0 1.219-.764 1.219-1.708 0-.084-.009-.166-.018-.247.007 0 .012.003.018.003a.487.487 0 00.345-.833zm6.486-1.607c-.108 0-2.659.018-4.248 1.607a.487.487 0 00.345.832c.006 0 .012-.003.017-.003-.007.081-.017.163-.017.247 0 .944.546 1.708 1.22 1.708.674 0 1.219-.764 1.219-1.708 0-.55-.189-1.035-.479-1.348a6.807 6.807 0 011.944-.36.489.489 0 00-.001-.975z",
  fill: "#664500"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "comments-and-reactions-metric_svg__clip0_10176_12195"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.667 .379)",
  d: "M0 0h202v43.913H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "comments-and-reactions-metric_svg__clip1_10176_12195"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(13.84 13.553)",
  d: "M0 0h17.565v17.565H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "comments-and-reactions-metric_svg__clip2_10176_12195"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(53.362 13.553)",
  d: "M0 0h17.565v17.565H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "comments-and-reactions-metric_svg__clip3_10176_12195"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(92.884 13.553)",
  d: "M0 0h17.565v17.565H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "comments-and-reactions-metric_svg__clip4_10176_12195"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(132.406 13.553)",
  d: "M0 0h17.565v17.565H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "comments-and-reactions-metric_svg__clip5_10176_12195"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(171.927 13.553)",
  d: "M0 0h17.565v17.565H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "comments-and-reactions-metric_svg__filter0_dd_10176_12195",
  x: -31.333,
  y: -15.621,
  width: 266,
  height: 107.913,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 16
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10176_12195"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_10176_12195",
  result: "effect2_dropShadow_10176_12195"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect2_dropShadow_10176_12195",
  result: "shape"
})));

var SvgCommentsAndReactionsMetric = function SvgCommentsAndReactionsMetric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 45,
    viewBox: "0 0 203 45",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/comments-and-reactions-metric.700d2590.svg";
export { SvgCommentsAndReactionsMetric as ReactComponent };